// extracted by mini-css-extract-plugin
export default {"vCode":"index_vCode_iVm4R clearfix","input":"index_input_t3so-","getMsgPinBtn":"index_getMsgPinBtn_ZIaHk","disable":"index_disable_XM5mm"};